<template>
  <div class="TopicAnswer">
    <Popup
      @closed="closedAnswer"
      :value="value"
      position="bottom"
      :overlay="true"
      @click-overlay="$emit('input', false)"
    >
      <div class="directory">
        <div class="directory-top">
          <div class="name">查看答案</div>
          <div class="topic-number">
            <span
              class="index"
              :class="{ active: i === activeIndex }"
              v-for="(item, i) in T.index"
              :key="i"
              @click="activeIndex = i"
              >{{ item }}题</span
            >
          </div>
          <div class="close" @click="$emit('input', false)">
            <img src="../img/close.png" alt="" />
          </div>
        </div>
        <div class="content" v-if="T.type == 1 || T.type == 2">
          <div class="correct-answer">
            正确答案：{{ T.answer.map(r => LetterArr[r]).join("") }}
          </div>
          <div class="answer-name">试题解析</div>
          <div class="analysis rich-text">
            <div v-html="T.answerContentHtml || T.answerContent"></div>
          </div>
        </div>
        <div class="content" v-else>
          <div class="correct-answer">
            正确答案：{{
              T.sonQuestion[activeIndex].answer.map(r => LetterArr[r]).join("")
            }}
          </div>
          <div class="answer-name">试题解析</div>
          <div class="analysis rich-text">
            <div
              v-if="T.answerContentHtml || T.answerContent"
              v-html="T.answerContentHtml || T.answerContent"
            ></div>
            <div
              v-if="
                T.sonQuestion[activeIndex].answerContentHtml ||
                  T.sonQuestion[activeIndex].answerContent
              "
              v-html="
                T.sonQuestion[activeIndex].answerContentHtml ||
                  T.sonQuestion[activeIndex].answerContent
              "
            ></div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
import { Popup } from "vant";
import { LetterArr } from "@/components/topic/utils/topic";
export default {
  name: "TopicAnswer",
  props: {
    value: Boolean,
    T: {
      //当前大题对象
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data: function() {
    return {
      activeIndex: 0,
      LetterArr: LetterArr
    };
  },
  methods: {
    closedAnswer() {
      this.activeIndex = 0;
    }
  },
  components: { Popup }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../css/var";
.TopicAnswer {
  .directory {
    height: 100vh;
    padding: 0 16px;
    background: #fff;
    .directory-top {
      display: flex;
      width: 100%;
      height: 52px;
      justify-content: space-between;
      align-items: center;
      .close {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 5px;
        img {
          width: 12px;
          height: 12px;
        }
      }
      .topic-number {
        flex: 1;
        margin: 0 10px;
        overflow-x: auto;
        white-space: nowrap;
        display: inline-block;
        border-radius: 2px;
        .index {
          font-size: 13px;
          color: #5f6f8b;
          padding: 4px 6px;
          background: #f3f5f9;
          margin-right: 10px;
          &.active {
            /*background: #FFF;*/
            color: $--color-primary;
          }
        }
      }
      .name {
        font-size: 15px;
        color: #222;
      }
    }
    .content {
      /*height: calc(100% - 70px);*/
      /*overflow-y: auto;*/
      /*margin-bottom: 10px;*/
      .analysis {
        padding: 13px 0;
        height: calc(100vh - 230px);
        overflow-y: auto;
        & > div {
          width: 100%;
        }
        video {
          width: 100%;
        }
        audio {
          width: 100%;
        }
        img {
          width: 100%;
        }
      }
      .correct-answer {
        display: flex;
        width: 100%;
        height: 50px;
        align-items: center;
        padding: 0 14px;
        font-size: 16px;
        color: #fff;
        background: #37343d;
      }
      .answer-name {
        display: flex;
        width: 100%;
        height: 60px;
        align-items: center;
        font-size: 15px;
        color: #222;
        border-bottom: 1px solid #f3f5f9;
      }
    }
  }
}
</style>
